export default {
    title_list: 'Concierge Service',
    title_page: 'Concierge Service',
    title_create_page: 'Create a Concierge Service',
    title_edit_page: 'Edit Concierge Service',

    filter: {
        labels: {
            user_id: 'User',
            braintree_id: 'Braintree ID',
        }
    },

    table: {
        labels: {
            id: 'ID',
            created_at: 'Date',
            user_id: 'User',
            payment: 'Payment',
            status: 'Status',
            is_concierge_bundle: 'Is Bundle Virtual Concierge',
        }
    },

    buttons: {

    },

    form: {
        user_id: 'User',
        braintree_id: 'Braintree ID',
        created_at: 'Date',
        status: 'Status',
        is_concierge_bundle: 'Is Bundle Virtual Concierge',
    },
}
